import type * as core from '../../../../../../../core'

export const PACKAGE = {
  contents: [
    'package:data.higherEd.gl',
    'package:data.higherEd.research.idc.coreFunctions',
    'resource:data.enums.idcRateGroup',
    'resource:data.enums.idcRateGroup.federalOther',
    'resource:data.enums.idcRateGroup.federalResearchTraining',
    'resource:data.enums.idcRateGroup.federalStandard',
    'resource:data.enums.idcRateGroup.nonFederal',
    'resource:data.dimensions.glIdcGroups',
    'resource:data.dimensions.glIdcGroups.entities.group',
    'resource:data.dimensions.glIdcGroups.entities.group.attributes.isSponsored',
    'resource:data.dimensions.glIdcGroups.entities.group.attributes.isOnCampus',
    'resource:data.dimensions.glIdcGroups.entities.group.attributes.idcRateGroup',
    'resource:data.dimensions.glIdcGroups.entities.group.attributes.idcRate',
    'resource:data.dimensions.glExpenses.entities.entry.attributes.idcGroup',
    'resource:data.dimensions.glExpenseIdcFunctionalization',
    'resource:data.dimensions.glExpenseIdcFunctionalization.entities.entry',
    'resource:data.dimensions.glExpenseIdcFunctionalization.entities.entry.attributes.weight',
    'resource:data.dimensions.glExpenseIdcFunctionalization.entities.entry.attributes.idcFunction',
    'resource:data.dimensions.glExpenseIdcFunctionalization.entities.entry.attributes.expense',
    'resource:data.dimensions.glExpenseIdcFunctionalization.entities.entry.attributes.exclusionGroup',
    'resource:data.dimensions.glExpenseIdcFunctionalization.entities.entry.attributes.adjustmentGroup',
  ],
  description: 'TODO',
  name: 'IDC Data - GL',
} as const satisfies core.quiver.Package
